export default __webpack_public_path__ + "static/761-12159b401322648a475087467f61b57c.gif";